import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { ShipmentTransportOrderItemFacade } from '../shipment-transport-order-item.facade';
import { ShipmentTransportOrderOuterPackagesFacade } from './shipment-transport-order-outer-packages.facade';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { TransportOrderIdView } from '../../../../models';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderOuterPackagesGuard {
  constructor(
    private shipmentTransportOrderOuterPackagesFacade: ShipmentTransportOrderOuterPackagesFacade,
    private shipmentTransportOrderItemFacade: ShipmentTransportOrderItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentTransportOrderItemFacade.shipmentTransportOrderIdentifier$.pipe(
      take(1),
      switchMap((identifier: TransportOrderIdView) => {
        this.shipmentTransportOrderItemFacade.loadShipmentTransportOrderNotificationListCount(identifier);

        return loadStoreState(this.shipmentTransportOrderOuterPackagesFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentTransportOrderOuterPackagesFacade);
  }
}
